import { create } from 'zustand';

type UserRole = 'developer-portal' | 'publisher-portal' | 'admin-portal' |  null;
export interface WhiteListInputState {
  role: UserRole;
  userAllowed: boolean | null;
}
interface TempState {
  tempDeveloperInput: WhiteListInputState;
  tempPublisherInput: WhiteListInputState; // for publisher
  tempAdminInput: WhiteListInputState;
}

interface TempStateAction {
  setTempDeveloperInput<K extends keyof WhiteListInputState>(
    key: K,
    value: WhiteListInputState[K],
  ): void;
  setTempPublisherInput<K extends keyof WhiteListInputState>(
    key: K,
    value: WhiteListInputState[K],
  ): void;
  setTempAdminInput<K extends keyof WhiteListInputState>(
    key: K,
    value: WhiteListInputState[K],
  ): void;
}

type TempStateType = TempState & TempStateAction;

export const useTemporaryInputState = create<TempStateType>((set) => ({
  tempDeveloperInput: {
    role: null,
    userAllowed: null,
  },
  tempPublisherInput: {
    role: null,
    userAllowed: null,
  },
  tempAdminInput: {
    role: null,
    userAllowed: null,
  },
  setTempDeveloperInput: (key, value) => {
    set((state) => ({
      tempDeveloperInput: {
        ...state.tempDeveloperInput,
        [key]: value,
      },
    }));
  },
  setTempPublisherInput: (key, value) => {
    set((state) => ({
      tempPublisherInput: {
        ...state.tempPublisherInput,
        [key]: value,
      },
    }));
  },
  setTempAdminInput: (key, value) => {
    set((state) => ({
      tempAdminInput: {
        ...state.tempAdminInput,
        [key]: value,
      },
    }));
  },
}));
